export default __webpack_public_path__ + "static/media/sad-wanda.c659b612.png";